import {
  USER_POPUP_FETCH_STARTED,
  USER_POPUP_FETCH_SUCCEEDED,
  USER_POPUP_FETCH_FAILED,
  USER_POPUP_CHANGE_PAGE,
  USER_POPUP_SET_FILTER,
  USER_POPUP_OPEN_POPUP,
  USER_POPUP_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getRequestOptions } from '#helper';

const getUniqueDirectProjects = users => {
  const uniqueProjects = new Set();
  users.forEach(user => {
    user.directProjects.forEach(projectId => {
      uniqueProjects.add(projectId);
    });
  });

  return Array.from(uniqueProjects);
};

let abortController = new AbortController();

export const fetchProjectUsers = projectId =>
  async (dispatch, getState) => {
    try {
      const {
        page,
        itemsPerPage,
        order,
        orderBy,
        filter,
        filterBy
      } = getState().projectUsersPopup;
      let projects = [];

      abortController.abort();
      abortController = new AbortController();
      const { signal } = abortController;

      dispatch({
        type: USER_POPUP_FETCH_STARTED
      });

      const limit = itemsPerPage;
      const offset = (page - 1) * itemsPerPage;
      const searchParams = new URLSearchParams({
        order,
        orderBy,
        offset,
        limit,
        pagination: 1,
        project: projectId
      });

      if (filter && typeof filter === 'string') {
        searchParams.set('filterBy', filterBy);
        searchParams.set('filter', filter);
      }

      // Debounce to do not send multiple requests in short time
      await new Promise(res => {
        setTimeout(() => {
          res();
        }, 200);
      });

      const url = webPortalApi.buildApiUrl(`users?${searchParams.toString()}`);
      const res = await fetch(url, { ...getRequestOptions(), signal });

      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError('Response is not json');
      }
      if (!res.ok) {
        dispatch(
          snackBarError({
            message: 'Error in request'
          })
        );
      }

      const { users, last } = await res.json();

      if (users.length) {
        const directProjects = getUniqueDirectProjects(users);
        const projectsRes = await fetch(webPortalApi.buildApiUrl(`project?ids=${directProjects.join(',')}`), getRequestOptions());
        projects = await projectsRes.json();
      }

      const actionPayload = {
        type: USER_POPUP_FETCH_SUCCEEDED,
        payload: {
          users,
          projects,
          totalCount: last
        }
      };

      dispatch(actionPayload);
    } catch (e) {
      if (e.name === 'AbortError') {
        return;
      }
      dispatch({
        type: USER_POPUP_FETCH_FAILED,
        error: e
      });
    }
  };

export const setOpenPopup = isOpen => dispatch => {
  dispatch({
    type: USER_POPUP_OPEN_POPUP,
    payload: isOpen
  });
};

export const changePage = (
  newPage,
  projectId,
  addMode,
  editForm,
  refetch = true
) => dispatch => {
  dispatch({
    type: USER_POPUP_CHANGE_PAGE,
    payload: newPage
  });

  if (refetch) {
    dispatch(fetchProjectUsers(projectId, addMode, editForm));
  }
};

export const setFilter = (newFilter, projectId, addMode, editForm) => dispatch => {
  dispatch({
    type: USER_POPUP_SET_FILTER,
    payload: newFilter
  });

  dispatch(fetchProjectUsers(projectId, addMode, editForm));
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch({
    type: USER_POPUP_CLEAR
  });
};
